import { WidgetTableColumn } from '../../types/widgets/widgetDatasourceTable';
import { OF } from '../../util/network';
import { JBaseApi } from '../base';
import { jArticleList, jArticleLittle } from '../../types/article';
import { ApiWrapper, Format } from '../../types/utils';
import { jFileLittle } from '../../types/file';

export type DatasourceResultSortOrder = 'ascending' | 'descending';
export type DatasourceResultSort = {
    order: DatasourceResultSortOrder;
    name: string;
};

export type DatasourceResult<T extends {} = {}> = {
    type: DatasourceType;
    count_result: number;
    result_in_cache: boolean;
    model: WidgetTableColumn[];
    sort: DatasourceResultSort;
    data: T[];
    datasource: {
        datasourceType: DatasourceType;
        datasourceIdentifier: string;
    };
};

export type DatasourceModel = WidgetTableColumn[];

export type DatasourceStudioLittle = {
    mainType: 'typeApplication';
    title: string;
    img: string;
    icon: string;
    color: string;
    description: string;
};

export type DatasourceArticleLittle = jArticleLittle & { mainType: 'article' };

export type jDatasourceArticleList = jArticleList & {
    datasourceType: string;
    datasourceIdentifier: string;
    datasourceParameters: string | null;
    datasourceModel: string | null;
};

export type DatasourceType = 'calc' | 'calc-attachment' | 'studio' | 'doc' | 'external-api';

export type jDatasourceExcel = {
    file: jFileLittle;
    fileUrl?: string;
    spreadsheetList: string[];
    spreadsheetListHeaders: Record<string, string[]>;
};

export class JDatasourceApi extends JBaseApi {
    public get<T extends {}>(uri: string, format: Format): Promise<ApiWrapper<DatasourceResult<T>>> {
        return this.network.post({ o: 'widget', f: 'datasourceGet', uri, format } as OF);
    }

    public getModel(uri: string): Promise<ApiWrapper<{ type: DatasourceType; model: DatasourceModel }>> {
        return this.network.post({ o: 'widget', f: 'datasourceGetModel', uri } as OF);
    }

    public cancel(uri: string): Promise<ApiWrapper<boolean>> {
        return this.network.post({ o: 'widget', f: 'datasourceCancel', uri } as OF);
    }

    public getObject(uri: string): Promise<ApiWrapper<DatasourceArticleLittle | DatasourceStudioLittle>> {
        return this.network.post({ o: 'widget', f: 'datasourceGetObject', uri } as OF);
    }

    public updateModel(uri: string, model: DatasourceModel): Promise<ApiWrapper<boolean>> {
        return this.network.post({ o: 'widget', f: 'datasourceUpdateModel', uri, model } as OF);
    }

    public getExcelDatasource(uri: string): Promise<ApiWrapper<jDatasourceExcel>> {
        return this.network.post({ o: 'widget', f: 'datasourceGetExcelDatasource', uri } as OF);
    }

    public getExcelDatasourceHeaders(uri: string, spreadsheet?: string): Promise<ApiWrapper<string[]>> {
        return this.network.post({ o: 'widget', f: 'datasourceGetExcelDatasourceHeaders', uri, spreadsheet } as OF);
    }

    public setExcelDatasource(uri: string, spreadsheet: string): Promise<ApiWrapper<DatasourceModel>> {
        return this.network.post({ o: 'widget', f: 'datasourceSetExcelDatasource', uri, spreadsheet } as OF);
    }

    public create({
        title,
        datasourceType,
        datasourceIdentifier,
        token,
    }: {
        title: string;
        datasourceType: DatasourceType;
        datasourceIdentifier: string;
        token?: string;
    }): Promise<ApiWrapper<{ uri: string; model: DatasourceModel }>> {
        return this.network.postCSRF({
            o: 'widget',
            f: 'datasourceCreate',
            title,
            datasourceType,
            datasourceIdentifier,
            token,
        } as OF);
    }
}
